// src/components/ui/CyberCorners.tsx
// Shared corner components for the cyberpunk frame style

interface CornerProps {
    color: string;
}

export const CornerTL = ({ color }: CornerProps) => (
    <svg width="9" height="7" viewBox="0 0 9 7" fill="none">
        <path d="M0 0H8.32V1.5H1.51V6.2H0V0Z" fill={color} />
    </svg>
);

export const CornerBL = ({ color }: CornerProps) => (
    <svg width="9" height="6" viewBox="0 0 9 6" fill="none">
        <path d="M0 6.2H8.32V4.7H1.51V0H0V6.2Z" fill={color} />
    </svg>
);

export const CornerTR = ({ color }: CornerProps) => (
    <svg width="8" height="7" viewBox="0 0 8 7" fill="none">
        <path d="M8.32 0H0V1.5H6.81V6.2H8.32V0Z" fill={color} />
    </svg>
);

export const CornerBR = ({ color }: CornerProps) => (
    <svg width="8" height="6" viewBox="0 0 8 6" fill="none">
        <path d="M8.32 6.2H0V4.7H6.81V0H8.32V6.2Z" fill={color} />
    </svg>
);

// Helper component that renders all 4 corners
interface CyberCornersProps {
    color: string;
}

export function CyberCorners({ color }: CyberCornersProps) {
    return (
        <>
            <div className="absolute top-0 left-0 z-10 corner">
                <CornerTL color={color} />
            </div>
            <div className="absolute bottom-0 left-0 z-10 corner">
                <CornerBL color={color} />
            </div>
            <div className="absolute top-0 right-0 z-10 corner">
                <CornerTR color={color} />
            </div>
            <div className="absolute bottom-0 right-0 z-10 corner">
                <CornerBR color={color} />
            </div>
        </>
    );
}
